import api from "@/service/api";

const state = () => ({
    saving: false,
    error: null,
    throttle: null,
    recommendation: null,
})

const mutations = {
    setThrottle(state, value) {
        state.throttle = value;
    },
    setError(state, value) {
        state.error = value;
    },
    setSaving(state, value) {
        state.saving = value;
    },
    setRecommendation(state, value) {
        state.recommendation = value;
    },
}

const getErrorMessage = (error) => {
    if (
        error?.response?.data?.code === 'chargeFailed'
        && error?.response?.data?.message
    ) {
        return error.response.data.message;
    }

    if (
        error?.response?.data?.code === 'cardRestricted'
        && error?.response?.data?.message
    ) {
        return error.response.data.message;
    }

    return "There was an error charging your card, check your information and try again"
}

const handleChargeError = (commit, error) => {
    const code = error?.response?.data?.code;
    const recommendation = error?.response?.data?.recommendation;

    if (code === "recommendFintech" && recommendation) {
        commit("setRecommendation", recommendation);
        return;
    }

    if (error?.response?.data?.throttle) {
        commit("setThrottle", error?.response?.data?.throttle);
    }

    commit("setError", getErrorMessage(error));
}

const actions = {
    chargeDefault({ commit }, { priceId }) {
        commit("setError", null);
        commit("setRecommendation", null);
        commit("setSaving", true);

        api
            .post("/authorize/chargeDefault", { priceId })
            .then(() => {
                commit("wallet/setPurchaseComplete", true, { root: true });
            })
            .catch((error) => {
                handleChargeError(commit, error);
            })
            .then(() => {
                commit("setSaving", false);
            });
    },
    transaction({ commit }, { priceId, card, year, month, code, postalCode, countryId, save }) {
        commit("setError", null);
        commit("setRecommendation", null);
        commit("setSaving", true);

        api
            .post("/authorize/transaction", { priceId, card, year, month, code, postalCode, countryId, save })
            .then(() => {
                commit("wallet/setPurchaseComplete", true, { root: true });
            })
            .catch((error) => {
                handleChargeError(commit, error);
            })
            .then(() => {
                commit("setSaving", false);
            });
    },
    // deprecated methods below
    createAndChargeCard({ commit }, { priceId, card, year, month, code, postalCode, countryId }) {
        commit("setError", null);
        commit("setRecommendation", null);
        commit("setSaving", true);

        api
            .post("/authorize/createAndChargeCard", { priceId, card, year, month, code, postalCode, countryId })
            .then(() => {
                commit("wallet/setPurchaseComplete", true, { root: true });
            })
            .catch((error) => {
                handleChargeError(commit, error);
            })
            .then(() => {
                commit("setSaving", false);
            });
    },
    chargeCard({ commit }, { priceId, userCreditCardId }) {
        commit("setError", null);
        commit("setRecommendation", null);
        commit("setSaving", true);

        api
            .post("/authorize/chargeCard", { priceId, userCreditCardId })
            .then(() => {
                // should not refer to wallet here
                commit("wallet/setPurchaseComplete", true, { root: true });
            })
            .catch((error) => {
                handleChargeError(commit, error);
            })
            .then(() => {
                commit("setSaving", false);
            });
    },
}


export default {
    namespaced: true,
    state,
    actions,
    mutations
}
